import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import * as React from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import LockIcon from '@mui/icons-material/Lock';
import { useI18N } from '../../context/I18NContext';
import { useTheme } from '@mui/material';
import { CustomTextFieldElement } from '../../layouts/Theme';
export default function PasswordField(props) {
    var _a, _b;
    const { t } = useI18N();
    const theme = useTheme();
    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    return (_jsx(CustomTextFieldElement, { required: (_a = props === null || props === void 0 ? void 0 : props.required) !== null && _a !== void 0 ? _a : true, label: props.label ? t(props.label, 'register') : t('Wachtwoord', 'register'), name: (_b = props.name) !== null && _b !== void 0 ? _b : 'password', type: showPassword ? 'text' : 'password', autoComplete: "new-password", disabled: typeof props.disabled === 'boolean' && props.disabled, InputProps: {
            startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(LockIcon, { sx: { color: theme.palette.text.secondary } }) })),
            endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { "aria-label": showPassword ? t('Verberg het wachtwoord', 'register') : t('Toon het wachtwoord', 'register'), onClick: handleClickShowPassword, edge: "end", children: showPassword ? _jsx(VisibilityOffIcon, { sx: { color: theme.palette.text.secondary } }) : _jsx(VisibilityIcon, { sx: { color: theme.palette.text.secondary } }) }) }))
        }, sx: {
            my: 2,
            "& .MuiOutlinedInput-root": {
                paddingTop: "8px"
            },
            "& .MuiInputLabel-formControl:not(.MuiInputLabel-shrink)": {
                transform: "translate(14px, 20px) scale(1)" // translate(14px, 16px) scale(1);
            },
            "& .MuiInputLabel-shrink": {
                transform: "translate(14px, 4px) scale(0.75)" // translate(14px, -9px) scale(0.75);
            },
            "& .MuiOutlinedInput-notchedOutline": {
                top: 0,
                "& legend": {
                    display: 'none'
                }
            }
        }, fullWidth: true }));
}
